import { BasedataFormData } from 'src/modules/basedata/types/BasedataFormData';
import { createTrigger } from 'src/utils/createTrigger';

export const BASEDATA_CHANGE = createTrigger<BasedataFormData>('BASEDATA_CHANGE');
